"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { ArrowRight, Lock } from "lucide-react";
import type { CatalogRow } from "@/features/onboarding-tours/orchestrator/get-catalog-page";
import type { TourId } from "@/features/onboarding-tours/types/tour-definition";
import { cn } from "@/lib/utils";
interface TourCatalogTourRowProps {
  row: CatalogRow;
  onStartTour: ({
    tourId
  }: {
    tourId: TourId;
  }) => void;
  onLockedTourClick: () => void;
}
const cardClassName = cn("group relative flex h-full min-h-[10.5rem] flex-col rounded-lg border p-4 text-left transition-colors duration-150");
function TourCatalogCardContent(t0) {
  const $ = _c(13);
  const {
    row
  } = t0;
  let t1;
  if ($[0] !== row.categoryLabel) {
    t1 = <p className="text-[11px] font-medium uppercase tracking-wider text-muted-foreground/80">{row.categoryLabel}</p>;
    $[0] = row.categoryLabel;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = row.isLocked ? "text-muted-foreground" : "text-foreground";
  let t3;
  if ($[2] !== t2) {
    t3 = cn("mt-2 text-sm font-medium leading-snug tracking-tight", t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== row.title || $[5] !== t3) {
    t4 = <h3 className={t3}>{row.title}</h3>;
    $[4] = row.title;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== row.description) {
    t5 = <p className="mt-1.5 line-clamp-2 flex-1 text-xs leading-relaxed text-muted-foreground">{row.description}</p>;
    $[7] = row.description;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t1 || $[10] !== t4 || $[11] !== t5) {
    t6 = <>{t1}{t4}{t5}</>;
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}
function TourCatalogCardAction(t0) {
  const $ = _c(9);
  const {
    isLocked,
    lockedLabel
  } = t0;
  const t1 = isLocked ? "text-muted-foreground transition-colors group-hover:text-foreground" : "text-primary transition-colors group-hover:text-primary/80";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("mt-auto inline-flex items-center gap-1 pt-4 text-xs font-medium", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== isLocked || $[3] !== lockedLabel) {
    t3 = isLocked ? <><Lock aria-hidden={true} className="size-3 shrink-0" />{lockedLabel ?? "Upgrade to unlock"}</> : "Start tour";
    $[2] = isLocked;
    $[3] = lockedLabel;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ArrowRight aria-hidden={true} className="size-3 shrink-0 transition-transform group-hover:translate-x-0.5" />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t3) {
    t5 = <span className={t2}>{t3}{t4}</span>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}
export function TourCatalogTourRow(t0) {
  const $ = _c(22);
  const {
    row,
    onStartTour,
    onLockedTourClick
  } = t0;
  if (row.isLocked) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = cn(cardClassName, "cursor-pointer border-border/40 bg-muted/10 hover:border-border/70 hover:bg-muted/20", "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2");
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] !== row) {
      t2 = <TourCatalogCardContent row={row} />;
      $[1] = row;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== row.lockedLabel) {
      t3 = <TourCatalogCardAction isLocked={true} lockedLabel={row.lockedLabel} />;
      $[3] = row.lockedLabel;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    let t4;
    if ($[5] !== onLockedTourClick || $[6] !== t2 || $[7] !== t3) {
      t4 = <li className="min-h-0"><button className={t1} onClick={onLockedTourClick} type="button">{t2}{t3}</button></li>;
      $[5] = onLockedTourClick;
      $[6] = t2;
      $[7] = t3;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    return t4;
  }
  let t1;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn(cardClassName, "border-border/50 bg-card hover:border-border hover:bg-muted/20");
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  let t2;
  if ($[10] !== row) {
    t2 = <TourCatalogCardContent row={row} />;
    $[10] = row;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("mt-auto inline-flex w-fit items-center gap-1 pt-4 text-left text-xs font-medium text-primary", "transition-colors hover:text-primary/80", "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:rounded-sm");
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== onStartTour || $[14] !== row.id) {
    t4 = () => {
      onStartTour({
        tourId: row.id
      });
    };
    $[13] = onStartTour;
    $[14] = row.id;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ArrowRight aria-hidden={true} className="size-3 shrink-0" />;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t4) {
    t6 = <button className={t3} onClick={t4} type="button">Start tour{t5}</button>;
    $[17] = t4;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t2 || $[20] !== t6) {
    t7 = <li className="min-h-0"><article className={t1}>{t2}{t6}</article></li>;
    $[19] = t2;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}